import mainReducer from "./mainReducer";
import adminReducer from "./adminReducer";
import { combineReducers } from "redux";

const allReducers = combineReducers({
    mainReducer,
    adminReducer
});

export default allReducers